export enum SETTINGS_ACTION_TYPE {
  GET = 'settings/get',
  SAVE = 'settings/save',
}
